import * as React from "react";
import { format } from "date-fns";
import { Table } from "components";
import { useCurrentCase, useOrganizationSettings } from "duck";
import { Fragments, MedicationFrequencyEnum } from "requests";
import { Edit } from "./components";
import { FREQUENCY_TO_TITLE } from "./duck";

interface MedicationsTableProps {
  selectedKeys: (string | number)[];
  onChange(ids: (string | number)[]): void;
}

const MedicationsTable: React.FC<MedicationsTableProps> = ({
  selectedKeys,
  onChange
}) => {
  const meds = useCurrentCase(
    ({ data }) => data.client.patient.currentMedications
  );
  const { dateFormat } = useOrganizationSettings();

  return (
    <Table data={meds} rowSelection={{ selectedKeys, onChange }}>
      <Table.Column dataKey="medication" label="Name" />
      <Table.Column dataKey="dose" label="Dose" />
      <Table.Column<MedicationFrequencyEnum>
        dataKey="frequency"
        label="Frequency"
        render={({ value }) => FREQUENCY_TO_TITLE[value]}
      />
      <Table.Column<string>
        dataKey="lastGivenAt"
        label="Last Given"
        render={({ value }) =>
          format(new Date(value), `${dateFormat}, h:mm aa`)
        }
      />
      <Table.Column<undefined, Fragments.StoredCurrentMedications[number]>
        w="70px"
        render={({ record }) => <Edit record={record} />}
      />
    </Table>
  );
};

export default MedicationsTable;
